import { Pipe, PipeTransform } from '@angular/core';
import { EntityMap } from '@ngrx/signals/entities';
import { TherapyJobNotification } from '../models/TherapyJobNotification';
import { getIndex } from '../utils/getCriticalNotificationType';

@Pipe({
  standalone: true,
  name: 'filterNotification'
})
export class FilterNotificationPipe implements PipeTransform {
  transform(entityMap: EntityMap<TherapyJobNotification>, id: string): Array<TherapyJobNotification> {
    if (!entityMap) {
      return [];
    }
    return Object.keys(entityMap)
      .filter((key) => key.endsWith(`-${id}`))
      .sort((a, b) => {
        const aLevel = getIndex(entityMap[a].level);
        const bLevel = getIndex(entityMap[b].level);
        return aLevel - bLevel;
      })
      .map((key) => entityMap[key]);
  }
}
